module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_library.js
 ** module id = 297
 ** module chunks = 12
 **/